// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"26089566","56":"156649ad","1698":"18581021","2860":"5583c8ec","3115":"5d21d299","4242":"9b0b4364","4483":"7bae20aa","5431":"40d945be","8697":"5d21d299"}[chunkId] + ".chunk.css";
};